<template>
  <div>
    <dx-data-grid
      ref="grid"
      :dataSource="dataSource"
      :allow-column-reordering="true"
      @exporting="gridExporting"
      :column-min-width="120"
      column-resizing-mode="widget"
      :allow-column-resizing="true"
      :column-auto-width="true"
      width="100%"
    >
      <dx-remote-operations :group-paging="true"></dx-remote-operations>
      <dx-header-filter :visible="true">
        <dx-search :enabled="searchEnabled" mode="contains"></dx-search>
      </dx-header-filter>
      <dx-selection :mode="selectionMode"></dx-selection>
      <dx-grouping :context-menu-enabled="true"></dx-grouping>
      <dx-group-panel :visible="true"></dx-group-panel>
      <dx-paging :enabled="true" :page-size="20" :page-index="0"></dx-paging>
      <dx-pager
        :visible="true"
        :show-navigation-buttons="false"
        :show-info="true"
        :show-page-size-selector="false"
      ></dx-pager>
      <dx-search-panel :visible="true" width="240"></dx-search-panel>
      <dx-scrolling :scroll-by-content="true"></dx-scrolling>
      <dx-filter-panel :visible="true"></dx-filter-panel>
      <dx-filter-row :visible="true"></dx-filter-row>
      <dx-column-chooser :enabled="columnChooserEnabled"></dx-column-chooser>
      <dx-state-storing
        :enabled="stateStoringEnabled"
        :storage-key="storageKey"
      ></dx-state-storing>
      <dx-editing
        :allow-adding="bolehBaru"
        :allow-updating="bolehEdit"
        :allow-deleting="bolehHapus"
        :use-icons="true"
      ></dx-editing>
      <dx-export
        :enabled="bolehExport"
        :formats="gridExportFormats"
      ></dx-export>
      <dx-toolbar>
        <dx-item name="groupPanel"></dx-item>
        <dx-item name="searchPanel"></dx-item>
        <dx-item v-if="bolehExport" name="exportButton"></dx-item>
        <dx-item name="columnChooserButton"></dx-item>
        <dx-item
          v-for="(item, index) in toolbarItems"
          :key="`toolbar-${index}`"
          :location="item.location || 'before'"
          :widget="item.widget"
          :options="item.options"
        ></dx-item>
        <dx-item
          location="after"
          widget="dxButton"
          :options="{ icon: 'refresh', onClick: onRefresh }"
        >
        </dx-item>
        <dx-item
          v-if="bolehBaru"
          location="after"
          widget="dxButton"
          :options="{ icon: 'add', onClick: onBaru }"
        ></dx-item>
      </dx-toolbar>
      <dx-column type="buttons">
        <dx-button
          v-if="bolehEdit"
          icon="fas fa-edit"
          @click="onEdit"
        ></dx-button>
        <dx-button
          v-if="bolehHapus"
          icon="fas fa-trash"
          @click="onHapus"
        ></dx-button>
        <dx-button
          v-if="bolehCetak"
          icon="fas fa-print"
          @click="onCetak"
        ></dx-button>
      </dx-column>

      <dx-column
        v-for="(item, index) in columns"
        :key="index"
        :data-field="item.dataField"
        :caption="item.caption"
        :data-type="item.dataType"
        :format="getColumnFormat(item)"
        :visible="item.visible"
        :cell-template="item.cellTemplate"
      ></dx-column>
      <dx-summary>
        <dx-total-item
          v-for="(item, index) in totalItems"
          :key="index"
          :summary-type="item.summaryType"
          :column="item.column"
          display-format="{0}"
          :value-format="item.valueFormat"
        ></dx-total-item>
      </dx-summary>
    </dx-data-grid>
  </div>
</template>

<script>
import GridHelper from "@/helper/grid-helper";
import {
  DxDataGrid,
  DxSearch,
  DxToolbar,
  DxItem,
  DxButton,
  DxColumn,
  DxSummary,
  DxTotalItem,
  DxColumnChooser,
  DxStateStoring,
  DxFilterRow,
  DxExport,
  DxEditing,
  DxScrolling,
  DxFilterPanel,
  DxGroupPanel,
  DxSelection,
  DxGrouping,
  DxSearchPanel,
  DxHeaderFilter,
  DxPaging,
  DxPager,
  DxRemoteOperations,
} from "devextreme-vue/data-grid";

export default {
  components: {
    DxDataGrid,
    DxSearch,
    DxToolbar,
    DxItem,
    DxButton,
    DxColumn,
    DxSummary,
    DxTotalItem,
    DxColumnChooser,
    DxStateStoring,
    DxFilterRow,
    DxExport,
    DxEditing,
    DxScrolling,
    DxFilterPanel,
    DxGroupPanel,
    DxSelection,
    DxGrouping,
    DxSearchPanel,
    DxHeaderFilter,
    DxRemoteOperations,
    DxPaging,
    DxPager,
  },
  methods: {
    onCetak(e) {
      this.$emit("cetak", e);
    },
    gridExporting: GridHelper.onExporting,
    getColumnFormat(col) {
      switch (col.dataType) {
        case "date":
          return "dd-MM-yyyy HH:mm:ss";
        case "number":
          return "#,##0.##;(#,##0.##)";
        default:
          return "";
      }
    },
  },
  props: {
    // Extra toolbar widgets, e.g. a quick filter (UAT #1452): [{ location, widget, options }].
    toolbarItems: {
      type: Array,
      default: () => [],
    },
    searchEnabled: {
      type: Boolean,
      default: true,
    },
    columnChooserEnabled: {
      type: Boolean,
      default: true,
    },
    selectionMode: {
      type: String,
      default: "none",
    },
    totalItems: {
      type: Array,
      default: () => [],
    },
    storageKey: {
      type: String,
      default: "grid",
    },
    gridExportFormats: {
      type: Array,
      default: () => ["xlsx", "csv", "pdf"],
    },
    onBaru: {
      type: Function,
      default: () => {},
    },
    onEdit: {
      type: Function,
      default: () => {},
    },
    onHapus: {
      type: Function,
      default: () => {},
    },
    onRefresh: {
      type: Function,
      default: () => {},
    },
    bolehBaru: {
      type: Boolean,
      default: false,
    },
    bolehEdit: {
      type: Boolean,
      default: false,
    },
    bolehHapus: {
      type: Boolean,
      default: false,
    },
    bolehExport: {
      type: Boolean,
      default: false,
    },
    bolehCetak: {
      type: Boolean,
      default: false,
    },
    daftar: {
      type: Object || Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["cetak"],
  computed: {
    stateStoringEnabled() {
      return this.storageKey.length > 0;
    },
    instance() {
      return this.$refs.grid.instance;
    },
    dataSource: {
      get() {
        return this.daftar;
      },
      set(value) {
        this.$emit("update:daftar", value);
      },
    },
  },
};
</script>
